<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import List from './list_types/List'
import Editor from './list_types/Editor'
import BottomSheet from '../BottomSheet'
export default {
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/settings/list_types/list'
    },
    {
      path: "new",
      name: "New list type",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      }
    },
    {
      path: "edit/:id",
      name: "Edit list type",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      }
    },
    {
      path: "list",
      name: "List types list",
      component: List
    }
  ],
}
</script>
